<div class="flex flex-row items-stretch justify-center m-auto gap-2">
    <app-select-by-group
        class="w-52"
        [defaultValue]="defaultSourceOptions()"
        [isDisabled]="mapEditModeService.isEditingGeometryActive()"
        [isMultiSelect]="true"
        [optionsByGroup]="optionsByGroup()"
        [placeholder]="'editMode.layerSnap'"
        (optionSelected)="selectLayerOptions($event)" />
    <app-select
        class="w-44"
        [canClear]="false"
        [defaultValue]="defaultDistanceOption()"
        [isDisabled]="mapEditModeService.isEditingGeometryActive() || !mapEditModeService.selectedSnapSources().length"
        [placeholder]="'editMode.pxDistance'"
        [(options)]="layerDistances"
        [(selectedOptions)]="selectedDistanceOptions"
        (optionSelected)="selectDistancesOptions($event)" />
</div>
